import React from "react";
import { Grid } from "@mui/material";
import { useFormikContext } from "formik";
import { VehicleFormValues, VehicleOwnershipType } from "../../../validation/vehicleValidationSchema";
import { VehicleTextField, VehicleDateField } from "../VehicleFormFields";
import {
  OwnerInfoForm,
  LeaseFromForm,
  LeaseToForm,
  OwnershipSelector,
} from "../../../../../components/common/OwnershipForms";

interface OwnershipTabProps {
  availableLessors?: Array<{ id: number; name: string }>;
  availableLessees?: Array<{ id: number; name: string }>;
}

const OwnershipTab: React.FC<OwnershipTabProps> = ({
  availableLessors = [],
  availableLessees = [],
}) => {
  const formik = useFormikContext<VehicleFormValues>();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {/* Ownership Type Selector */}
        <OwnershipSelector
          value={formik.values.ownershipType || VehicleOwnershipType.CompanyOwned}
          onChange={(ownershipType) => {
            formik.setFieldValue('ownershipType', ownershipType);
            // Clear conditional fields when ownership type changes
            if (ownershipType !== VehicleOwnershipType.NotCompanyOwned) {
              formik.setFieldValue('ownerInfo', null);
            }
            if (ownershipType !== VehicleOwnershipType.CompanyOwnedLeasedFrom) {
              formik.setFieldValue('leaseFromInfo', null);
            }
            if (ownershipType !== VehicleOwnershipType.CompanyOwnedLeasedTo) {
              formik.setFieldValue('leaseToInfo', null);
            }
          }}
          entityType="vehicle"
          error={formik.touched.ownershipType && formik.errors.ownershipType ? String(formik.errors.ownershipType) : undefined}
        />

        {/* Owner Information Form (for NotCompanyOwned) */}
        <OwnerInfoForm
          ownershipType={formik.values.ownershipType || VehicleOwnershipType.CompanyOwned}
          entityType="vehicle"
          TextFieldComponent={VehicleTextField}
        />

        {/* Lease From Form (for CompanyOwnedLeasedFrom) */}
        <LeaseFromForm
          showForm={(formik.values.ownershipType || VehicleOwnershipType.CompanyOwned) === VehicleOwnershipType.CompanyOwnedLeasedFrom}
          availableLessors={availableLessors}
          entityType="vehicle"
          TextFieldComponent={VehicleTextField}
          DateFieldComponent={VehicleDateField}
        />

        {/* Lease To Form (for CompanyOwnedLeasedTo) */}
        <LeaseToForm
          showForm={(formik.values.ownershipType || VehicleOwnershipType.CompanyOwned) === VehicleOwnershipType.CompanyOwnedLeasedTo}
          availableLessees={availableLessees}
          entityType="vehicle"
          TextFieldComponent={VehicleTextField}
          DateFieldComponent={VehicleDateField}
        />
      </Grid>
    </Grid>
  );
};

export default OwnershipTab;
